import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import {useIntl} from 'react-intl';
// import arrowIcon from 'src/assets/icons/arrowIcon.svg';
import riskScoreFrame from 'src/assets/icons/scoreFrame.svg';
import {GetStylesFunction} from 'src/js/common/types';
import {TranslateUtils} from 'src/js/common/utils';

import {DlMuiTypography} from './DlMuiTypography';

interface OwnProps {
  data: any;
  top?: string | number;
  left?: string | number;
}

type Props = OwnProps;

const addPx = (value: string | number): string => {
  return typeof value === 'string' ? value : `${value}px`;
};
export const DlMuiRiskScoreFrame: React.FC<Props> = (props) => {
  const {data, left = 77, top = 5} = props;

  const isRiskScorePositive = data?.riskScoreChange > 0;
  const isRiskScoreZero = data?.riskScoreChange === 0;

  const theme = useTheme();
  const intl = useIntl();
  const styles = getStyles({
    theme,
    params: {
      isRiskScorePositive,
      top: addPx(top),
      left: addPx(left),
    },
  });

  const translatedRiskScoreTitle = intl && TranslateUtils.translate('patient.card.riskScore', intl);

  return (
    <>
      <div css={styles.riskScoreFrameWrapper}>
        <SvgIcon css={styles.riskScoreFrame} component={riskScoreFrame} inheritViewBox {...props} />
      </div>
      <div css={styles.riskScoreWrapper}>
        <div css={styles.riskScoreContent}>
          <DlMuiTypography
            css={styles.typography}
            variant={'riskScoreValue'}
            value={data?.riskScoreValue}
            title={`${translatedRiskScoreTitle} - ${data?.riskScoreValue}`}
          />
          {/* TODO-JK: not required in first version */}
          {/* {isRiskScoreZero ? null : ( */}
          {/*  <div css={styles.riskScoreChangeWrapper}> */}
          {/*    <SvgIcon */}
          {/*      css={styles.arrowIcon} */}
          {/*      component={arrowIcon} */}
          {/*      inheritViewBox */}
          {/*      {...props} */}
          {/*    /> */}
          {/*    <DlMuiTypography */}
          {/*      css={styles.typography} */}
          {/*      variant={'riskScoreChange'} */}
          {/*      value={data.riskScoreChange} */}
          {/*    /> */}
          {/*  </div> */}
          {/* )} */}
        </div>
      </div>
    </>
  );
};

DlMuiRiskScoreFrame.displayName = 'DlMuiRiskScoreFrame';

const getStyles: GetStylesFunction = (options) => {
  const {isRiskScorePositive, left, top} = options?.params ?? {};
  return {
    riskScoreWrapper: css`
      display: flex;
      flex-direction: row;
      position: absolute;
      width: 106px;
      height: 106px;
      left: ${left};
      top: ${top};
      gap: ${options?.theme?.spacing(1)};
      justify-content: center;
      align-items: center;
    `,
    riskScoreChangeWrapper: css`
      display: flex;
      flex-direction: column;
      padding-top: ${options?.theme?.spacing(0.5)};
      gap: ${options?.theme?.spacing(0.5)};
    `,
    riskScoreFrame: css`
      width: 106px;
      height: 106px;
    `,
    riskScoreContent: css`
      display: flex;
      gap: ${options?.theme?.spacing(1)};
    `,
    arrowIcon: css({
      color: `${options?.theme?.palette.custom.white}`,
      width: '10px',
      height: '12px',
      transform: `${isRiskScorePositive ? 'rotate(0deg)' : 'rotate(180deg)'}`,
    }),
    typography: css({
      color: `${options?.theme?.palette.custom.white}`,
      cursor: 'default',
    }),
    riskScoreFrameWrapper: css`
      position: absolute;
      left: ${left};
      top: ${top};
    `,
  };
};
